import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHypertrackerLiquidationsMenuItem = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.33335 11.3334L8.00002 10.6667L7.66669 11.3334H8.33335Z",
			stroke: "#1A1B23",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.33335 11.3334L8.00002 10.6667L7.66669 11.3334H8.33335Z",
			stroke: "white",
			strokeOpacity: .5,
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 14.6666C10.1768 14.6666 10.3464 14.5964 10.4714 14.4714C10.5965 14.3464 10.6667 14.1768 10.6667 14V13.3333C10.9178 13.3332 11.1638 13.2621 11.3763 13.1283C11.5888 12.9945 11.7592 12.8034 11.8679 12.577C11.9766 12.3506 12.0191 12.0981 11.9906 11.8486C11.962 11.5991 11.8636 11.3627 11.7067 11.1666C12.4707 10.4282 12.9967 9.47834 13.2172 8.43893C13.4378 7.39953 13.3428 6.31794 12.9445 5.33285C12.5463 4.34777 11.8628 3.50411 10.9819 2.91004C10.1009 2.31598 9.06257 1.9986 8.00002 1.9986C6.93748 1.9986 5.89915 2.31598 5.01819 2.91004C4.13722 3.50411 3.45379 4.34777 3.05552 5.33285C2.65725 6.31794 2.56229 7.39953 2.78284 8.43893C3.00339 9.47834 3.52937 10.4282 4.29336 11.1666C4.1364 11.3627 4.038 11.5991 4.00948 11.8486C3.98096 12.0981 4.02349 12.3506 4.13216 12.577C4.24083 12.8034 4.41123 12.9945 4.62374 13.1283C4.83625 13.2621 5.08223 13.3332 5.33336 13.3333V14C5.33336 14.1768 5.40359 14.3464 5.52862 14.4714C5.65364 14.5964 5.82321 14.6666 6.00002 14.6666H10Z",
			stroke: "#1A1B23",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 14.6666C10.1768 14.6666 10.3464 14.5964 10.4714 14.4714C10.5965 14.3464 10.6667 14.1768 10.6667 14V13.3333C10.9178 13.3332 11.1638 13.2621 11.3763 13.1283C11.5888 12.9945 11.7592 12.8034 11.8679 12.577C11.9766 12.3506 12.0191 12.0981 11.9906 11.8486C11.962 11.5991 11.8636 11.3627 11.7067 11.1666C12.4707 10.4282 12.9967 9.47834 13.2172 8.43893C13.4378 7.39953 13.3428 6.31794 12.9445 5.33285C12.5463 4.34777 11.8628 3.50411 10.9819 2.91004C10.1009 2.31598 9.06257 1.9986 8.00002 1.9986C6.93748 1.9986 5.89915 2.31598 5.01819 2.91004C4.13722 3.50411 3.45379 4.34777 3.05552 5.33285C2.65725 6.31794 2.56229 7.39953 2.78284 8.43893C3.00339 9.47834 3.52937 10.4282 4.29336 11.1666C4.1364 11.3627 4.038 11.5991 4.00948 11.8486C3.98096 12.0981 4.02349 12.3506 4.13216 12.577C4.24083 12.8034 4.41123 12.9945 4.62374 13.1283C4.83625 13.2621 5.08223 13.3332 5.33336 13.3333V14C5.33336 14.1768 5.40359 14.3464 5.52862 14.4714C5.65364 14.5964 5.82321 14.6666 6.00002 14.6666H10Z",
			stroke: "white",
			strokeOpacity: .5,
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.99998 8.66665C10.3682 8.66665 10.6666 8.36817 10.6666 7.99998C10.6666 7.63179 10.3682 7.33331 9.99998 7.33331C9.63179 7.33331 9.33331 7.63179 9.33331 7.99998C9.33331 8.36817 9.63179 8.66665 9.99998 8.66665Z",
			stroke: "#1A1B23",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.99998 8.66665C10.3682 8.66665 10.6666 8.36817 10.6666 7.99998C10.6666 7.63179 10.3682 7.33331 9.99998 7.33331C9.63179 7.33331 9.33331 7.63179 9.33331 7.99998C9.33331 8.36817 9.63179 8.66665 9.99998 8.66665Z",
			stroke: "white",
			strokeOpacity: .5,
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.99998 8.66665C6.36817 8.66665 6.66665 8.36817 6.66665 7.99998C6.66665 7.63179 6.36817 7.33331 5.99998 7.33331C5.63179 7.33331 5.33331 7.63179 5.33331 7.99998C5.33331 8.36817 5.63179 8.66665 5.99998 8.66665Z",
			stroke: "#1A1B23",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.99998 8.66665C6.36817 8.66665 6.66665 8.36817 6.66665 7.99998C6.66665 7.63179 6.36817 7.33331 5.99998 7.33331C5.63179 7.33331 5.33331 7.63179 5.33331 7.99998C5.33331 8.36817 5.63179 8.66665 5.99998 8.66665Z",
			stroke: "white",
			strokeOpacity: .5,
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgHypertrackerLiquidationsMenuItem;
